/**
 * Created by Simone.Sacchi on 29/11/2017.
 */


"use strict";

module.exports = {

    getCsrfToken: function () {
        return $('meta[name="csrf-token"]').attr('content');
    },

    getCurrentlyActiveTab: function (tablistSelector) {
        // ul#institutions_details_sub_nav
        return $(tablistSelector + ' > li.active a').attr("aria-controls");
    },

    getSsiOwnerBic: function () {
        return $("#search__details__content--ssis .search_details_header a[data-feedback-type='bic']:visible").text() ||
            $(".search_details_header .current-bic:visible").attr('data-bic') ||
            "";
    },

    /**
     * Build a microservice url
     *
     * ex call: buildMicroserviceUrl(["autocomplete", "e1s1", "reachable", "bic"]);
     * ex response: /services/autocomplete/e1s1/reachable/bic
     *
     * NOTE: if you want you can also pass the querystring because it will be concatenated
     * ex call: buildMicroserviceUrl(["autocomplete", "e1s1", "reachable", "bic", "a=test&b=a"]);
     * @param segments
     * @returns {string}
     */
    buildMicroserviceUrl: function (segments) {
        return window.Swiftref.base_url + "/services/" + segments.join("/");
    },

    /**
     * delete specified keys from object
     *
     * @param obj
     * @param keys array of keys
     * @returns {*}
     */
    deleteKeys: function (obj, keys) {

        var cloneObj = Object.assign({}, obj);

        keys.forEach(function (key) {

            if (cloneObj.hasOwnProperty(key)) {
                delete cloneObj[key];
            }
        });

        return cloneObj;
    },

    findParentByClass: function (element, className) {
        try {
            while (!element.classList.contains(className)) {
                element = element.parentNode;
            }
            return element;
        } catch (e) {}
    },
    findParentByTagName: function (element, tagName) {
        if (!element) {
            return;
        }
        while (element.tagName && element.tagName !== tagName) {
            element = element.parentNode;
        }
        return element;
    },

    // used for feedback, to return the current section
    getCurrentCategory: function (hash) {
        var currentCategory = "";

        if (hash && hash.tab) {
            currentCategory = hash.tab;

            if (hash.tab === 'countries_currencies') {
                currentCategory = 'cch';
            }
        } else {
            if (window.location.pathname) {
                if (window.location.pathname.indexOf("ssipath") !== -1) {
                    currentCategory = 'ssi_path';
                }
                if (window.location.pathname.indexOf("iban") !== -1) {
                    currentCategory = 'iban_validator';
                }
                if (window.location.pathname.indexOf("cch") !== -1) {
                    currentCategory = 'cch';
                }
                if (window.location.pathname.indexOf("download") !== -1) {
                    currentCategory = 'download_area';
                }
                if (window.location.pathname.indexOf("datacollection") !== -1) {
                    if (window.location.pathname.indexOf("4ec") !== -1) {
                        currentCategory = 'admin';
                    } else if(window.location.pathname.indexOf("gpi") !== -1) {
                        currentCategory = 'gpi';
                    }else if(window.location.pathname.indexOf("fee") !== -1) {
                        currentCategory = 'fees';
                    }else if(window.location.pathname.indexOf("sepa") !== -1) {
                        currentCategory = 'sepa';
                    }else if(window.location.pathname.indexOf("tradereadiness") !== -1) {
                        currentCategory = 'trade';
                    }
                }

                if (window.location.pathname.indexOf("g4cs") !== -1 && window.location.pathname.indexOf("datacollection") === -1) {
                    currentCategory = 'gpi_for_corporates';
                }
                if (window.location.pathname.indexOf("prevalidations") !== -1) {
                    currentCategory = 'preval_bav_service';
                }
                if (window.location.pathname.indexOf("sepaio") !== -1) {
                    currentCategory = 'sepa_iban';
                }
            }
        }

        return currentCategory;
    }


};
